import React, { forwardRef, useMemo } from 'react';
import Listbox from './Listbox';

function optionsFromChildren(children) {
  return React.Children.toArray(children)
    .filter((child) => React.isValidElement(child) && child.type === 'option')
    .map((child) => ({
      value: child.props.value == null ? '' : String(child.props.value),
      label: child.props.children,
      disabled: Boolean(child.props.disabled),
    }));
}

/**
 * Form-oriented Select: prefers `options`, or parses `<option>` children.
 * Built on reusable `Listbox`.
 */
const Select = forwardRef(function Select(
  {
    children,
    options: optionsProp,
    required: _required = false,
    placeholder = 'Select…',
    ...rest
  },
  ref
) {
  const options = useMemo(() => {
    if (Array.isArray(optionsProp) && optionsProp.length > 0) {
      return optionsProp.map((opt) => ({
        value: opt.value == null ? '' : String(opt.value),
        label: opt.label,
        disabled: Boolean(opt.disabled),
      }));
    }
    return optionsFromChildren(children);
  }, [optionsProp, children]);

  const resolvedPlaceholder =
    options.find((opt) => opt.value === '')?.label || placeholder;

  return (
    <Listbox
      ref={ref}
      options={options}
      placeholder={resolvedPlaceholder}
      {...rest}
    />
  );
});

export default Select;
